import React, { useState } from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import Close from 'lib/icons/close'

import Searchbox from '~/scenes/shared/searchbox'

import sceneLogic from '../logic'

const SearchBox = ({ children, categorySuggestions, performSearch, searchedQuery, alwaysDisplayed = false }) => {
  const [isSearchEnabled, setSearchEnabled] = useState(false)
  const [isContentAvailable, setContentAvailable] = useState(false)
  const [edited, setEdited] = useState(false)
  const { isSearchBoxVisible } = useValues(sceneLogic)
  const { toggleSearchBox } = useActions(sceneLogic)

  const withContent = edited ? isContentAvailable : isContentAvailable || !!searchedQuery

  const updateSearchUi = status => {
    if (isSearchEnabled !== status) {
      setSearchEnabled(status)
    }
  }

  const updateValue = value => {
    const isCurrentContentAvailable = !!value.trim().length
    if (isContentAvailable !== isCurrentContentAvailable) {
      setEdited(true)
      setContentAvailable(isCurrentContentAvailable)
    }
  }

  return (
    <div className={`item search${isSearchEnabled ? ' active' : ''}${withContent ? ' with-content' : ''}`}>
      {!alwaysDisplayed && (
        <div className='show-flex-under-640-screen custom-search'>
          {isSearchBoxVisible && (
            <Searchbox
              initialValue={searchedQuery}
              autoFocus
              updateValue={updateValue}
              updateSearchUi={updateSearchUi}
              isClearable
              id='header-tiny'
              categorySuggestions={categorySuggestions}
              withMagnifierIcon
            />
          )}
          {isSearchBoxVisible ? (
            <Close onClick={toggleSearchBox} color='green' />
          ) : (
            <div onClick={toggleSearchBox} className='magnifier-icon'>
              <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                <path d='M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
              </svg>
            </div>
          )}
        </div>
      )}
      <div className={`simple-search${alwaysDisplayed ? '' : ' hide-under-640-screen'}`}>
        <Searchbox
          performSearch={performSearch}
          initialValue={searchedQuery}
          updateValue={updateValue}
          updateSearchUi={updateSearchUi}
          isClearable
          id='header-searchbox'
          categorySuggestions={categorySuggestions}
          withMagnifierIcon
        />
      </div>
      {children}
    </div>
  )
}

SearchBox.propTypes = {
  children: PropTypes.node,
  categorySuggestions: PropTypes.array,
  alwaysDisplayed: PropTypes.bool,
  performSearch: PropTypes.func,
  searchedQuery: PropTypes.string
}

export default SearchBox
